import * as actionTypes from './actionTypes';

export const getDropDownDataFailed = (error) => ({
    type:actionTypes.GET_DROPDOWN_DATA_FAILED,
    error
});

export const getDropDownDataStart  = () =>({ type: actionTypes.GET_DROPDOWN_DATA });

export const setDropdownData = (category, value) => ({
    type: actionTypes.SET_DROPDOWN_DATA,
    category,
    value
});
